import { render, staticRenderFns } from "./eventos-table.vue?vue&type=template&id=640012f5&"
import script from "./eventos-table.vue?vue&type=script&lang=js&"
export * from "./eventos-table.vue?vue&type=script&lang=js&"
import style0 from "./eventos-table.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640012f5')) {
      api.createRecord('640012f5', component.options)
    } else {
      api.reload('640012f5', component.options)
    }
    module.hot.accept("./eventos-table.vue?vue&type=template&id=640012f5&", function () {
      api.rerender('640012f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/eventos-table/eventos-table.vue"
export default component.exports